import { cn } from "@/lib/utils";

interface AdminTabActionBarProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Full-width action row rendered directly below the admin breadcrumb bar.
 * The negative margins cancel AdminLayout's content padding so every tab can
 * use the same edge-to-edge action surface without moving tab state upward.
 */
const AdminTabActionBar = ({ children, className }: AdminTabActionBarProps) => (
  <div
    className={cn(
      "admin-secondary-bar",
      className,
    )}
  >
    {children}
  </div>
);

export default AdminTabActionBar;
